import Header from "./components/Header/Header";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import MobileResetPassword from "./components/mobileResetPassword/mobileResetPassword";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import HackTimer from "./scripts/hacktimer/HackTimer";

function App() {

  return (
    <div className="App" style={window.innerWidth < 500 ? {margin: 0} : {}}>
      <BrowserRouter>
        {
          window.innerWidth < 500 ? 
            <MobileResetPassword /> : 
            <>
              <Header />
              <ResetPassword />
            </>
        }
      </BrowserRouter>
    </div>
  );
}

export default App;
